module.exports = __webpack_public_path__ + "media/wenweihai.7a1883b3.mp4";